<template>
  <span v-on:click="clicktolink" class="spanLinkToTemplate">
    <slot></slot>
  </span>
    <!--<a data-template="sellinone" data-clear="true" class="linkToTemplate" href="#" v-on:click="clicktolink" >-->
    <!--<button type="button" class="btn btn-info btn-lg ">-->
    <!--<i class="fa fa-shopping-cart"></i> Új vásárlás-->
    <!--</button>-->
    <!--</a>-->

</template>

<script>
    import i18n from '@/i18n';
    import Helper from '@/helper/Helper';

    export default {
        name: 'linktotemplate',
        props: {
            template: String,
            clear: String,
        },
        methods: {
            clicktolink(e){
                console.log("clicktolink");
                const modul = this;
                e.preventDefault();
                // Unfortunetly can't possible check before the redirection, because we can't access that informations
                //             if(Helper.checkRoles()){}
                modul.$router.push({name: modul.template})
                modul.$eventBus.$emit('globalReset', {name: modul.template});
            },
        }
    };
</script>

<style>
    .cursor {
        cursor: pointer;
    }
</style>

